import React from "react";
import Navbar from "../components/Navbar";
import PageHero from "../components/PageHero";
import Marquee from "../components/Marquee";
import MotorcycleSection from "../components/MotorcycleSection";
import TechnologySection from "../components/TechnologySection";
import VideoSection from "../components/VideoSection";
import GallerySection from "../components/GallerySection";
import CTASection from "../components/CTASection";
import Footer from "../components/Footer";
import { MOTO_HERO, MOTO_FILMS, LINKS } from "../mock/data";

export default function MotorcyclePage() {
  return (
    <div className="App bg-[#0a0a0a] overflow-x-hidden">
      <Navbar />
      <PageHero
        image={MOTO_HERO}
        kicker="Motorcycle Lighting"
        title="RIDE INTO THE NIGHT"
        subtitle="Vibration-tested auxiliary lights, compact pods and headlight kits for adventure, dual-sport and touring machines."
        shopLink={LINKS.motoShop}
      />
      <Marquee />
      <MotorcycleSection />
      <TechnologySection />
      <VideoSection
        films={MOTO_FILMS}
        kicker="Motorcycle Films"
        title="SETUP & STORIES"
        subtitle="Watch real Baja Designs motorcycle tutorials and product stories from the official channel."
      />
      <GallerySection />
      <CTASection />
      <Footer />
    </div>
  );
}
